<template>
  <Notification :description="$t('plus_notification_hotel_connect')" v-bind="$attrs">
    <template #ctaContent>
      <div class="tw:mt-3 tw:md:mt-0 tw:shrink-0">
        <BaseLinkButton
          size="medium"
          class="tw:w-full tw:font-bold tw:text-blue-800 tw:text-nowrap"
          @click="updateContactDetails"
        >
          <span>{{ $t('notifications_cta_update') }}</span>
        </BaseLinkButton>
      </div>
    </template>
  </Notification>
</template>

<script setup>
import Notification from './Notification.vue'
import BaseLinkButton from '@/components/base/buttons/BaseLinkButton.vue'

import { useRouter } from 'vue-router'

const router = useRouter()
const updateContactDetails = () => {
  router.push({ name: 'property-details-basic-information', query: { open_update: true } })
}
</script>
